<template>
  <div v-if="showPopUp" class="pop-up" @click="handleClick($event)">
    <div class="pop-up-wrapper" @click.stop>
      <div class="pop-up-content">
        <div class="pop-up-text">
          <slot name="content"></slot>
        </div>
        <img src="../assets/tip-icon.png" class="pop-up-icon" alt="" />
        <div class="pop-up-btn">
          <div class="cancel-btn" @click="cancelPopUp">取消</div>
          <div class="confirm-btn" @click="confirmPopUp">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Vue, Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ConfirmPop extends Vue {
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  get showPopUp() {
    return this.value;
  }

  set showPopUp(value: any) {
    this.$emit('input', value);
  }

  handleClick(e: any) {
    this.showPopUp = false;
  }

  cancelPopUp() {
    this.$emit('cancelApply');
  }

  confirmPopUp() {
    this.$emit('confirmApply');
  }
}
</script>

<style lang="scss" scoped>
@import '../style/base.scss';
.pop-up {
  @include hei_wid(100%, 100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  font-family: PingFangSC-Medium, PingFang SC;
  background-color: rgba(0, 0, 0, 0.7);
}
.pop-up-wrapper {
  @include flex_center(center, true);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pop-up-content {
  @include hei_wid(616px, 550px);
  position: relative;
  padding: 108px 50px 0;
  background: $whiteColor;
  border-radius: 24px;
}
.pop-up-text {
  height: 376px;
  overflow: auto;
}
.pop-up-icon {
  @include hei_wid(250px, 250px);
  position: absolute;
  top: -125px;
  left: 50%;
  transform: translateX(-50%);
}
.pop-up-btn {
  @include flex_center(space-between, true);
  margin: 32px 0;
}
.cancel-btn {
  @include hei_wid(68px, 200px);
  color: $purpleColor;
  line-height: 68px;
  text-align: center;
  background: #eaeaf5;
  border-radius: 44px;
}
.confirm-btn {
  @include hei_wid(68px, 200px);
  @include font_color(28px, none, 500, $whiteColor);
  line-height: 68px;
  text-align: center;
  background: $purpleColor;
  border: 2px solid $purpleColor;
  border-radius: 44px;
}
</style>